<template>
    <div class="table-none">
        <div>
            <svg class="icon"
                 aria-hidden="true">
                <use xlink:href="#icon-none1"></use>
            </svg>
        </div>
        <span>暂无数据</span>
    </div>
</template>

<script>
export default {
    name: 'tableEmpty'

}
</script>

<style lang="scss">
.table-none {
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .icon {
        width: 100px;
        height: 100px;
    }

    span {
        line-height: 14px;
    }
}
</style>
